import { render } from "./RuleStopGroup.vue?vue&type=template&id=4b35b381&scoped=true"
import script from "./RuleStopGroup.vue?vue&type=script&lang=js"
export * from "./RuleStopGroup.vue?vue&type=script&lang=js"

import "./RuleStopGroup.vue?vue&type=style&index=0&id=4b35b381&scoped=true&lang=css"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b35b381"]])

export default __exports__